// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {StarsCommonLayout} from 'app_components/commons/stars'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IStarsCommonProps {
  starts: number
  amount?: number
}
interface IStarsCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class StarsCommon extends Component<IStarsCommonProps, IStarsCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IStarsCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <StarsCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(StarsCommon)
